import { environment } from '@env/environment';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SecureHttp } from '@app/security/secure-http';
import { SessionService } from '@app/security/session.service';
import { ExperienceNotificationThrottlingMetrics } from '../models/notification-throttling';
import { map, Observable } from 'rxjs';
import { Direction, Ordering } from '../utils/ordering';

export interface NotificationThrottlingServiceT {
  getMetrics(
    page: number,
    pageSize: number,
    ordering: Ordering,
  ): Observable<ExperienceNotificationThrottlingMetrics[]>;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationThrottlingService {
  constructor(
    private sessionService: SessionService,
    private http: SecureHttp,
  ) {}

  getExperienceNotificationThrottlingMetrics(
    page: number = 1,
    pageSize: number = 50,
    ordering: Ordering,
  ): Observable<ExperienceNotificationThrottlingMetrics[]> {
    const clientId = this.sessionService.currentUser.client.id;
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    if (ordering) {
      const dir = ordering.direction === Direction.Asc ? 'ASC' : 'DESC';
      params = params
        .set('sortField', ordering.orderBy)
        .set('sortDirection', dir);
    }
    let url = `${
      environment.portalURLBase
    }/client/${clientId}/throttler/metrics?${params.toString()}`;

    return this.http
      .get(url,null,true)
      .pipe(
        map(
          (response) =>
            response.data as ExperienceNotificationThrottlingMetrics[],
        ),
      );
  }
}
